import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3>{`Renditions on Demand`}</h3>
    <p>{`By default, we return a large number of renditions to support many different use cases. If you wish to pare down the response itself, GIPHY offers optional `}<strong parentName="p">{`renditions-on-demand bundles`}</strong>{` (RoD).`}<br /><br />{`By passing the bundle parameter, GIPHY will respond with only the renditions that pertain to that bundle. This is completely optional; you could also parse the response for the desired renditions yourself within your app.`}<br /></p>
    <p><strong parentName="p">{`Common RoD uses cases and filters`}</strong></p>
    <div className="rendition-on-demand">
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Use RoD filter parameter`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Implementation Guidelines`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Renditions included`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><strong parentName="td"><em parentName="strong">{`If your use case is`}</em></strong>{` Mobile/Desktop Application with Grid/Carousel Picker for Clips Content Type`}</td>
            <td parentName="tr" {...{
              "align": null
            }}></td>
            <td parentName="tr" {...{
              "align": null
            }}></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`clips_grid_picker`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Returns renditions with formats that are suitable for loading animated asset grids efficiently.`}<br /><br />{`Use the `}<inlineCode parentName="td">{`webp/mp4`}</inlineCode>{` URLs from the renditions in the `}<inlineCode parentName="td">{`image`}</inlineCode>{` object to load content quickly in the trending/search Grid. At this stage you will display the non sound version of the Clip in the grid to avoid loading multiple video players at once.`}<br /><br />{`Once the user has selected an content from the grid, use the available renditions from the video object to preview/send the selected clip (with sound)`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`data.images.fixed_width`}<br />{`data.images.original`}<br />{`data.video.assets.360p`}<br />{`data.video.assets.720p`}<br />{`data.video.assets.480p`}<br />{`data.video.assets.1080p`}<br />{`data.video.assets.source`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><strong parentName="td"><em parentName="strong">{`If your use case is`}</em></strong>{` Mobile/Desktop Application with Grid/Carousel Picker for Messaging using GIFs `}{`&`}{` Stickers`}</td>
            <td parentName="tr" {...{
              "align": null
            }}></td>
            <td parentName="tr" {...{
              "align": null
            }}></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`messaging_non_clips`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Returns renditions with formats that are suitable for loading animated asset grids efficiently.`}<br /><br />{`Use the `}<inlineCode parentName="td">{`webp/mp4`}</inlineCode>{` URLs from the renditions in the `}<inlineCode parentName="td">{`image`}</inlineCode>{` object to load content quickly in the trending/search Grid.`}<br /><br />{`Once the user has selected the content from the grid, use the largest possible rendition while sending the content in the message.`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`data.images.original`}<br />{`data.images.fixed_height`}<br />{`data.images.fixed_height_downsampled`}<br />{`data.images.fixed_height_small`}<br />{`data.images.fixed_width`}<br />{`data.images.fixed_width_downsampled`}<br />{`data.images.fixed_width_small`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><strong parentName="td"><em parentName="strong">{`If your use case is`}</em></strong>{` Mobile/Desktop Application with Grid/Carousel Picker for Sticker Layering in Photo/Video editing tools`}</td>
            <td parentName="tr" {...{
              "align": null
            }}></td>
            <td parentName="tr" {...{
              "align": null
            }}></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`sticker_layering`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Returns renditions with formats that are suitable for loading animated asset grids efficiently and layering transparent background sticker assets on the canvas.`}<br /><br />{`Use the `}<inlineCode parentName="td">{`webp/mp4`}</inlineCode>{` URLs from the renditions in the `}<inlineCode parentName="td">{`image`}</inlineCode>{` object to load content quickly in the trending/search Grid.`}<br /><br />{`Once the user has selected the sticker from the grid use the url/webP fields from the largest resolution to access the gif/webP formats as layers on top of the canvas`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`data.images.original`}<br />{`data.images.downsized_large`}<br />{`data.images.downsized_medium`}<br />{`data.images.fixed_height`}<br />{`data.images.fixed_height_downsampled`}<br />{`data.images.fixed_height_small`}<br />{`data.images.fixed_width`}<br />{`data.images.fixed_width_downsampled`}<br />{`data.images.fixed_width_small`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><strong parentName="td"><em parentName="strong">{`If your use case is`}</em></strong>{` Mobile/ Desktop Application with bandwidth limitations eg: MMS only allow assets less than 1MB`}</td>
            <td parentName="tr" {...{
              "align": null
            }}></td>
            <td parentName="tr" {...{
              "align": null
            }}></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`low_bandwidth`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Returns renditions with formats that are suitable for loading animated content grids efficiently with small size assets.`}<br /><br />{`Use `}<inlineCode parentName="td">{`webp/mp4`}</inlineCode>{` assets from fixed_height_small, fixed_width_small, fixed_width_downsampled, fixed_height_downsampled to load content quickly in the trending/search grid.`}<br /><br />{`Once the user has selected the content from the grid, select the suitable asset to send based on any additional bandwidth restrictions from any of the downsized renditions`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`data.images.original`}<br />{`data.images.downsized`}<br />{`data.images.downsized_large`}<br />{`data.images.downsized_medium`}<br />{`data.images.downsized_small`}<br />{`data.images.original`}<br />{`data.images.fixed_height_small`}<br />{`data.images.fixed_width_small`}<br />{`data.images.fixed_width_downsampled`}<br />{`data.images.fixed_height_downsampled`}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <p><strong parentName="p">{`Using RoD bundles for specific renditions`}</strong>{`
If there is a specific rendition you know that you want in a given context, RoD filters allow you to filter out all but that specific rendition.`}</p>
    <p>{`Example : only return stickers for a video editing app`}<br />{`
`}<inlineCode parentName="p">{`'https://api.giphy.com/v1/stickers/search?api_key={YOUR API KEY}&q=hello&bundle=sticker_layering'`}</inlineCode></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      